import * as React from 'react'
import classnames from 'classnames'

import Dropzone from 'react-dropzone'

import { IconName, IconPrefix } from '@fortawesome/fontawesome'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export interface FileDropzoneProps {
  title?: string
  isLoading?: boolean
  onDrop: (file: any) => void
}

class FileDropzone extends React.Component<FileDropzoneProps> {
  constructor(props) {
    super(props)

    this.onDrop = this.onDrop.bind(this)
  }

  onDrop(acceptedFiles) {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const { onDrop } = this.props

      const file = acceptedFiles[0]
      onDrop(file)
    }
  }

  render() {
    const { title, isLoading } = this.props

    const icon: [IconPrefix, IconName] = isLoading ? ['fas', 'spinner'] : ['fas', 'upload']

    return (
      <Dropzone onDrop={this.onDrop} disabled={isLoading}>
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <div {...getRootProps()} className="filedropzone">
              <input {...getInputProps()} />
                <FontAwesomeIcon
                  size="3x"
                  icon={icon as any}
                  spin={isLoading}
                  className="mb-4"
                />
                <p>
                  {isDragActive
                    ? 'Now drop it'
                    : isLoading
                      ? 'Uploading'
                      : title || 'Browse for files or drop them here'
                  }
                </p>
            </div>
          )
        }}
      </Dropzone>
    )
  }
}

export default FileDropzone



// WEBPACK FOOTER //
// ./src/common/FileDropzone.component.tsx